import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactModel } from '@boxx/contacts-core';
import { EventModel } from '@boxx/events-core';
import { LeadModel, ReviewsModel } from '@boxx/messages-core';
import { PanelPageModel } from '../models/panel.model';
import {
  IPanelAnalyticsPayload,
  IPanelAnalyticsResponse,
} from '@boxx/panel-core';
import { IEcwidDataStatistics } from '@boxx/gmb-core/lib/contracts/IEcwidData';

export interface IPanelService {
  getPanelData(): Observable<PanelPageModel>;
  getPanelAnalytics(
    filter?: IPanelAnalyticsPayload
  ): Observable<IPanelAnalyticsResponse>;
  getPanelContacts(): Observable<ContactModel[]>;
  getPanelEvents(): Observable<EventModel[]>;
  getPanelLeads(): Observable<{
    messages: LeadModel[];
    totals: { total: number; seen: number; new: number };
  }>;
  getPanelReviews(): Observable<ReviewsModel>;
  
  getEcwidStadistics(): Observable<IEcwidDataStatistics>;

}

export const PANEL_SERVICE = new InjectionToken<IPanelService>('panelService');
